import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7e6176e4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7e6176e4&prod&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=7e6176e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6176e4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconBase: require('/home/vsts/work/1/s/components/IconBase.vue').default})
